import { Type } from 'class-transformer';
import { INotification } from '../interfaces/notification.interface';

export class NotificationDTO implements INotification {
  id!: string;

  @Type(() => Date)
  creationDate!: Date;

  seen!: boolean;

  ticket!: { id: string; code: string; unit: { id: string } };
}
